import { cn } from '@baseball-near-you/ui';
import type { ChangeEvent } from 'react';

export function LargeCheckboxInput({
  label,
  onChange,
  className,
  checked,
  id,
}: {
  label: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  checked: boolean;
  id?: string;
}) {
  return (
    <label
      htmlFor={id ?? `${label}-checkbox`}
      className={cn(
        '!cursor-pointer flex flex-1 items-center rounded-md border-2 border-gray-200 p-3 transition-colors checked:bg-black',
        checked ? 'border-red bg-red/[8%]' : 'border-gray-300',
        className
      )}
    >
      <input
        id={id ?? `${label}-checkbox`}
        type="checkbox"
        className="size-4 rounded-md bg-gray-100 accent-red"
        checked={checked}
        onChange={(e) => {
          e.stopPropagation();
          onChange(e);
        }}
      />
      <span className="mx-2 w-full select-none font-medium text-gray-900 text-sm dark:text-gray-300">
        {label}
      </span>
    </label>
  );
}
